const prepareDangerouslySetHTML = html => ({ __html: html })

export default prepareDangerouslySetHTML
